import * as React from "react"

const IamPartnersIconSubcategory: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width="70"
    height="70" 
    enableBackground="new 0 0 70 70"
    viewBox="0 0 70 70"
  >
    <style>{".st1{fill:#fff}"}</style>
    <path
      d="M14.5 0h40.9C63.5 0 70 6.5 70 14.5v40.9c0 8-6.5 14.5-14.5 14.5h-41C6.5 70 0 63.5 0 55.5v-41C0 6.5 6.5 0 14.5 0z"
      style={{
        fill: "#028477",
      }}
    />
    <path
      d="m29.5 42.6 1.3-.7c.5-.3.7-1 .4-1.5L28.7 36c-.2-.4-.6-.6-1-.6-.2 0-.4 0-.6.1l-1.3.7c-.2.1-.4.1-.6.1-.6 0-1.1-.5-1.1-1.1v-1.5c0-.6-.5-1.1-1.1-1.1h-4.9c-.6 0-1.1.5-1.1 1.1v1.5c0 .6-.5 1.1-1.1 1.1-.2 0-.4 0-.6-.1l-1.3-.7c-.2-.1-.4-.1-.6-.1-.4 0-.8.2-1 .6l-2.5 4.2c-.3.5-.1 1.2.4 1.5l1.3.7c.7.4.7 1.5 0 1.9l-1.3.7c-.5.3-.7 1-.4 1.5l2.5 4.2c.2.4.6.6 1 .6.2 0 .4 0 .6-.1l1.3-.7c.2-.1.4-.1.6-.1.6 0 1.1.5 1.1 1.1V53c0 .6.5 1.1 1.1 1.1H23c.6 0 1.1-.5 1.1-1.1v-1.5c0-.6.5-1.1 1.1-1.1.2 0 .4 0 .6.1l1.3.7c.2.1.4.1.6.1.4 0 .8-.2 1-.6l2.5-4.2c.3-.5.1-1.2-.4-1.5l-1.3-.7c-.7-.3-.7-1.3 0-1.7zm-8.8 4.2c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3s3.3 1.5 3.3 3.3c0 1.8-1.5 3.3-3.3 3.3zM28.6 12.2c-.6-.6-1.6-.6-2.1 0-.6.6-.6 1.6 0 2.1l2.7 2.7c-10 .5-18 8.3-18.9 18.2l.2-.4c.6-1.1 1.8-1.8 3.1-1.8h.1c1.7-7.1 7.9-12.5 15.4-12.9l-2.6 2.6c-.6.6-.6 1.6 0 2.1.3.3.7.4 1.1.4s.8-.1 1.1-.4l5.3-5.3c.3-.3.4-.7.4-1.1 0-.4-.2-.8-.4-1.1-.1.1-5.4-5.1-5.4-5.1zM47.8 19.9c3.4 0 6.1-2.7 6.1-6.1 0-3.4-2.7-6.1-6.1-6.1s-6.1 2.7-6.1 6.1 2.7 6.1 6.1 6.1zM59.7 36.4V28c0-2.3-1.5-4.4-3.7-5.1l-3.2-.5c-.3-.1-.6.1-.7.3l-3.7 10.1c-.2.6-1 .6-1.2 0l-3.7-10.1c-.1-.2-.3-.4-.5-.4-.1 0-3.4.6-3.4.6-2.2.7-3.7 2.8-3.7 5.1v8.4c0 1.3 1 2.3 2.3 2.3h19.2c1.3 0 2.3-1.1 2.3-2.3zM62.4 38.4c-.1 1.7-1.5 2.8-3.3 2.9-1.3 7.6-7.8 13.5-15.6 14l2.6-2.6c.6-.6.6-1.6 0-2.1-.6-.6-1.6-.6-2.1 0l-5.3 5.3c-.6.6-.6 1.6 0 2.1l5.3 5.3c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.6-.6.6-1.6 0-2.1l-2.7-2.7c10.5-.7 18.9-9.4 18.9-20.1z"
      className="st1"
    />
    <path
      d="M49.1 22.2c-.1-.1-.3-.2-.5-.2H47c-.2 0-.4.1-.6.2-.2.2-.2.6-.1.8l.8 1.3-.4 3.3.8 2c.1.2.4.2.4 0l.8-2-.4-3.3.8-1.3c.3-.2.2-.5 0-.8z"
      className="st1"
    />
  </svg>
)
export default IamPartnersIconSubcategory
